import { useState } from 'react';

import type { Suggestion } from '@/features/search-bar/types';

export function useSearchSuggestions() {
    const [suggestions, setSuggestions] = useState<Suggestion[]>([]);
    const [selectedState, setSelectedState] = useState<string>('');
    const [loadingSuggestions, setLoadingSuggestions] = useState(false);

    // Fetch suggestions from backend
    const fetchSuggestions = async (searchQuery: string): Promise<void> => {
        if (!searchQuery.trim()) {
            setSuggestions([]);
            return;
        }

        setLoadingSuggestions(true);
        try {
            const params = new URLSearchParams({
                query: searchQuery,
            });

            if (selectedState) {
                params.append('state', selectedState);
            }

            const response = await fetch(
                `/search/suggestions?${params.toString()}`,
            );
            const data = await response.json();

            if (data.success) {
                const allSuggestions = [
                    ...data.data.cities,
                    ...data.data.states,
                    ...data.data.countries,
                    ...data.data.motels,
                ];
                setSuggestions(allSuggestions);
            }
        } catch (error) {
            console.error('Error fetching suggestions:', error);
        } finally {
            setLoadingSuggestions(false);
        }
    };

    return {
        suggestions,
        setSuggestions,
        loadingSuggestions,
        setSelectedState,
        fetchSuggestions,
    };
}
